const { voucherDealMap, getVoucherTypeId } = require('./voucherDealMap');
const { mapVouchers } = require('./mapVouchers');

const getColorByState = item => {
  if (item.PendingDelete) {
    return {
      backgroundColor: '#ffb0b0',
      borderColor: '#ffb0b0',
    };
  }

  if (item.Pending && item.Persisted) {
    return {
      backgroundColor: '#b4b0ff',
      borderColor: '#b4b0ff',
    };
  }

  if (item.Persisted) {
    return {
      backgroundColor: 'white',
      borderColor: '#666',
    };
  }

  if (item.Pending) {
    return {
      backgroundColor: '#b0ffb7',
      borderColor: '#b0ffb7',
    };
  }

  return {
    backgroundColor: '#ffb0fe',
    borderColor: '#ffb0fe',
  };
};

module.exports = {
  voucherDealMap,
  mapVouchers,
  getColorByState,
  getVoucherTypeId,
};
